// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"commissionTablesSection_itemContainer__9qw2m"};